import React, { useState } from 'react';
import Section from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown } from 'react-icons/fi';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-zinc-200 last:border-0">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
      >
        <span className="text-lg font-semibold text-zinc-900 group-hover:text-zinc-600 transition-colors">{question}</span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }}>
          <SafeIcon icon={FiChevronDown} className="text-zinc-500 w-5 h-5" />
        </motion.div>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-zinc-600 leading-relaxed">
              {answer}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      q: "Is this legal?",
      a: "Yes, absolutely. We use publicly available information, privacy policies, and technical analysis of known data practices. We do not hack or illegally access systems."
    },
    {
      q: "Do you access my personal data?",
      a: "No. You only provide us with a list of the app names you use. We do not ask for logins, passwords, or device access."
    },
    {
      q: "How long does it take?",
      a: "Your personalized audit report will be delivered securely to your email within 24–48 hours of submission."
    },
    {
      q: "Is this automated?",
      a: "No. While we use tools to gather data, every report is manually reviewed by a human to ensure the risks presented are accurate, contextual, and highly relevant to you."
    }
  ];

  return (
    <div id="faq" className="bg-white border-y border-zinc-200">
      <Section>
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-10 text-center text-zinc-950">
            Frequently Asked Questions
          </h2>
          <div className="divide-y divide-zinc-200">
            {faqs.map((faq, idx) => (
              <FAQItem key={idx} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
};

export default FAQ;